<template>
  <b-container class="manutencao">
    <div class="manutencao-content">
      <div class="manutencao-icon">
        <i class="fa fa-wrench"></i>
      </div>
      <h1 class="manutencao-title">Serviço em Manutenção</h1>
      <p class="manutencao-message">
        Estamos realizando melhorias em nosso sistema. Por favor, tente novamente
        em breve.
      </p>
      <p class="manutencao-submessage">
        Pedimos desculpas pelo inconveniente.
      </p>
      <b-button
        variant="primary"
        class="btn-voltar"
        to="/"
      >
        <i class="fa fa-home mr-2"></i>Voltar ao Início
      </b-button>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "Manutencao",
};
</script>

<style lang="scss" scoped>
.manutencao {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}

.manutencao-content {
  text-align: center;
  max-width: 500px;
}

.manutencao-icon {
  font-size: 4rem;
  color: var(--background-color-secondary);
  margin-bottom: 1.5rem;
}

.manutencao-title {
  font-size: calc(var(--font-size--default) * 2);
  font-weight: bold;
  color: var(--color-text-title, #2c456a);
  margin-bottom: 1rem;
}

.manutencao-message {
  font-size: var(--font-size--large);
  color: var(--text-primary-color);
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

.manutencao-submessage {
  font-size: var(--font-size--default);
  color: var(--color-text-destaques, #494949);
  margin-bottom: 2rem;
}

.btn-voltar {
  background-color: var(--background-color-secondary) !important;
  border-color: var(--background-color-secondary) !important;

  &:hover {
    background-color: var(--background-color-hover) !important;
    border-color: var(--background-color-hover) !important;
  }
}
</style>
